import home from "./Home.module.css";
import logo from "../../assets/images/logo_home.png"

import { motion } from "framer-motion";

export default function Home(props: { loggedIn: boolean; }) {
    const { loggedIn } = props;
    if (!loggedIn) return;
    return (
        <div className="container">
            <div className={home.layout}>
                <motion.h1
                    initial={{ y: -500 }}
                    animate={{ y: 0 }}
                    exit={{ y: -500 }}
                    transition={{ duration: 0.3, type: "spring", delay: 0.3 }}>
                    Welcome To
                </motion.h1>
                <motion.img
                    alt="logo"
                    src={logo}
                    className={home.image}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3, delay: 0.3 }}
                />
                <motion.div
                    initial={{ y: 500 }}
                    animate={{ y: 0 }}
                    exit={{ y: 500 }}
                    transition={{ duration: 0.3, type: "spring", delay: 0.3 }}>
                    <h1 style={{ marginTop: "24px" }}>Traxboards Meal Track System</h1>
                    <h1 style={{ marginTop: "0px" }}>PT HM Sampoerna Tbk.</h1>
                    <h1 style={{ marginTop: "0px" }}>2024</h1>
                </motion.div>
            </div>
        </div>
    )
}
